import { IonPage } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { SuccessTrialSessionWidget } from '../../widgets/SuccessTrialSessionWidget';

type SuccessTrialSessionPageProps = RouteComponentProps;

export function SuccessTrialSessionPage(props: SuccessTrialSessionPageProps) {
  return (
    <IonPage>
      <SuccessTrialSessionWidget {...props} />
    </IonPage>
  );
}
